import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsPanelShellComponent } from 'src/app/components/details-panel-shell/details-panel-shell.component';
import { CalendarDay, CalendarEntry } from '../calendar-month-panel/calendar.types';

// Shared "Better Calendar" (ADO #4484) day-agenda panel — opened from a day cell's "+N"
// indicator (see CalendarMonthPanelComponent's dayAgendaOpen output), lists every entry for that
// day. Extracted so the Contracts-section calendar (#4551) can reuse it verbatim.
@Component({
    selector: 'app-calendar-day-agenda-panel',
    imports: [CommonModule, DetailsPanelShellComponent],
    styleUrls: ['../details-panel-shell/panel-content.css', './entry-row.css', './calendar-day-agenda-panel.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './calendar-day-agenda-panel.component.html'
})
export class CalendarDayAgendaPanelComponent {
  @Input() visible = false;
  @Input() day: CalendarDay | null = null;
  @Input() locale = 'de-DE';
  /** Id of the entry currently shown in the consumer's detail panel, for the active-row highlight. */
  @Input() selectedEntryId: string | null = null;

  @Output() close = new EventEmitter<void>();
  @Output() entryClick = new EventEmitter<CalendarEntry>();

  /** Panel title, e.g. "Dienstag, 21. August 2026" — a formatted date, not literal UI copy, so it
   *  doesn't need $localize. */
  get title(): string {
    if (!this.day) return '';
    return new Intl.DateTimeFormat(this.locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(this.day.date);
  }

  trackByEntryId(_index: number, entry: CalendarEntry): string {
    return entry.id;
  }
}
